export const FormsConstants = {
  AW: {},
  RBA: {
    FieldNames: {
      FormType: 'formType',
      Sender: 'sender',
      LeadId: 'leadId',
      SessionId: 'sessionId',
    },
    FormTypes: {
      OnlineScheduling: '23',
      ConsultationRequest: '2',
      ServiceRequest: '5',
      JobInquiry: '18',
    },
  },
  Enterprise: {
    openModalEvent: 'openGenericModal',
    openFormEvent: 'openForm',
  },
};
